import React, { useEffect, useState, Fragment, useRef } from "react";
import { EstateComparisonTableContent } from '../../../Common/Table/tableContent';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const reportData = this.props.data;
        const contentRowNames = this.props.rowNames;
        const totalAmount = this.props.totalAmount;
        const keys = this.props.keys;

        return (
            <div className="pl-2 pr-2">
                <h3><center><u>Estate Comparison Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Estate: </b> {searchData.estate}</div>
                    <div className="col"><b> From Date: </b> {searchData.fromDate}</div>
                    <div className="col"><b> To Date: </b> {searchData.toDate}</div>
                </div>
                <div>
                    <table className="table table-bordered pb-3">
                        <thead>
                            <tr>
                                <th rowspan="2"> Date </th>
                                <th colspan="4" style={{ background: "lightgreen", textAlign: "right" }} > <center>Plucker collection </center> </th>
                                <th colspan="4" style={{ background: "lightgreen", textAlign: "right" }}> <center>Field collection </center></th>
                                <th colspan="5" style={{ background: "lightgreen", textAlign: "right" }}><center>Factory collection </center></th>
                                <th colspan="1"> <center>Other Estates </center></th>
                            </tr>
                            <tr style={{ fontSize: "14px" }}>
                                <th scope="col">Gross weight</th>
                                <th scope="col">Rounded Weight</th>
                                <th scope="col">Deduction</th>
                                <th scope="col">Net weight</th>
                                <th scope="col">Bag count</th>
                                <th scope="col">Gross weight</th>
                                <th scope="col">Net weight</th>
                                <th scope="col">Per bag average</th>
                                <th scope="col">Bag count</th>
                                <th scope="col">Gross weight</th>
                                <th scope="col">Deduction</th>
                                <th scope="col">Net weight</th>
                                <th scope="col">Per bag average</th>
                                <th scope="col">Gross weight</th>
                            </tr>
                        </thead>
                        <tbody>
                            <EstateComparisonTableContent
                                data={reportData}
                                contentRowNames={contentRowNames}
                                hasEdit={false}
                            />
                        </tbody>
                        <tfoot>
                            <tr style={{ textAlign: "right" }}>
                                <td><h6>Total</h6></td>
                                <td><h6>{totalAmount.pluckingGrossWeight}</h6></td>
                                <td><h6>{totalAmount.pluckingRoundedWeight}</h6></td>
                                <td><h6>{totalAmount.pluckingDeduction}</h6></td>
                                <td><h6>{totalAmount.pluckingNetWeight}</h6></td>
                                <td><h6>{totalAmount.fieldBagCount}</h6></td>
                                <td ><h6>{totalAmount.fieldGrossWeight}</h6></td>
                                <td><h6>{totalAmount.fieldNetWeight}</h6></td>
                                <td><h6>{totalAmount.fieldPerBagAverage}</h6></td>
                                <td><h6>{totalAmount.factoryBagCount}</h6></td>
                                <td><h6>{totalAmount.factoryGrossWeight}</h6></td>
                                <td><h6>{totalAmount.factoryDeduction}</h6></td>
                                <td><h6>{totalAmount.factoryNetWeight}</h6></td>
                                <td><h6>{totalAmount.factoryPerBagAverage}</h6></td>
                                <td><h6>{totalAmount.otherEstatesGrossWeight}</h6></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        );
    }
}